import WarningIcon from '@mui/icons-material/Warning';
import {
  Alert,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  TextField,
} from '@mui/material';
import React, { useState } from 'react';
import { isMobile, isTablet } from 'react-device-detect';
import CustomDialog from '../custom-dialog/custom-dialog';

interface ConfirmActionProps {
  message: string;
  action: (reason?: string) => void;
  isOpen: boolean;
  handleClose: any;
  isSevereAction?: boolean;
  confirmSevereActionTarget?: string[] | string;
  confirmSevereActionLabels?: string[];
  children: React.ReactNode;
  requireReason?: boolean;
  cancel_label?:string;
}

function ConfirmAction({
  message,
  action,
  requireReason,
  isOpen,
  handleClose,
  isSevereAction,
  confirmSevereActionTarget,
  confirmSevereActionLabels,
  children,
  cancel_label
}: ConfirmActionProps) {
  let targets: string[] = [];
  if (confirmSevereActionTarget)
    targets =
      typeof confirmSevereActionTarget === 'string'
        ? [confirmSevereActionTarget]
        : confirmSevereActionTarget;

  const [confirmationInputs, setConfirmationInputs] = useState<string[]>(
    Array(targets.length).fill('')
  );

  if (
    confirmSevereActionLabels &&
    confirmSevereActionLabels.length != targets.length
  ) {
    return (
      <Alert severity="error">An error occurred. Please contact us.</Alert>
    );
  }
  const [reason, setReason] = useState<string>('');

  console.log(confirmationInputs)
  console.log(targets)
  console.log(confirmSevereActionTarget)

  return (
    <CustomDialog
      fullWidth
      open={isOpen}
      onClose={() => {
        handleClose();
        setConfirmationInputs(Array(targets.length).map((item) => ''));
      }}
    >
      <DialogTitle>
        <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
          <WarningIcon fontSize="large" color="error" />
          <div>
            <b>{message}</b>
          </div>
        </div>
      </DialogTitle>

      <DialogContent>
        {children !== undefined && (
          <>
            {children}
            <br />{' '}
          </>
        )}

        {isSevereAction && (
          <>
            <FormControl fullWidth>
              {requireReason ? (
                <TextField
                  autoComplete="off"
                  placeholder={`Please explain why you are performing this action`}
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  required
                />
              ) : (
                targets.map((target, index) => (
                  <TextField
                    sx={{ mb: 1 }}
                    key={target}
                    autoComplete="off"
                    placeholder={`Type "${targets[index]}" to allow proceeding with this operation...`}
                    value={confirmationInputs[index]}
                    label={
                      confirmSevereActionLabels
                        ? confirmSevereActionLabels[index]
                        : `Type in '${targets[index]}'`
                    }
                    onChange={(e) => {
                      setConfirmationInputs(
                        confirmationInputs.map((inp, i) =>
                          i == index ? e.target.value : inp
                        )
                      );
                    }}
                  />
                ))
              )}
            </FormControl>
            <br /> <br />
          </>
        )}
        <div style={{ display: 'flex', gap: 10, justifyContent: 'center' }}>
          <Button
            size={(isMobile && !isTablet) ? 'small' : 'medium'}
            variant="outlined"
            disabled={
              isSevereAction &&
              (requireReason
                ? reason.length === 0
                : confirmationInputs
                    .map((item, index) => item == targets[index])
                    .some((item) => !item))
            }
            color="error"
            onClick={() => {
              action(reason);
              handleClose();
              setConfirmationInputs([]);
              setReason('');
            }}
          >
            Proceed
          </Button>
          <Button
            size={(isMobile && !isTablet) ? 'small' : 'medium'}
            variant="contained"
            color="primary"
            onClick={() => {
              handleClose();
              setConfirmationInputs([]);
              setReason('');
            }}
          >
            {cancel_label || 'Cancel'} 
          </Button>
        </div>
      </DialogContent>
    </CustomDialog>
  );
}

export default ConfirmAction;
